import React from "react";
import { Link } from "react-router-dom";
import { navigationLinks, companyInfo } from "../mockData";
import { Phone, Mail, MapPin, Facebook, Linkedin } from "lucide-react";
import logo from "../assets/logo_meet_enterprise-removebg-preview.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img
              src={logo}
              alt="Meet Enterprise"
              className="h-16 mb-5"
            />

            <p className="text-gray-400 text-sm leading-7">
              Premium manufacturer and exporter of high-quality dyes, chemicals,
              and industrial solutions trusted worldwide.
            </p>

            <div className="flex gap-3 mt-6">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center"
              >
                <Facebook className="w-5 h-5" />
              </a>

              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-sky-500 flex items-center justify-center"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path d="M18.244 2H21.5l-7.12 8.138L22.75 22h-6.555l-5.13-6.707L5.2 22H1.94l7.617-8.704L1.5 2h6.722l4.637 6.118L18.244 2z" />
                </svg>
              </a>

              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-700 flex items-center justify-center"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-lg font-bold mb-5">Quick Links</h3>

            <ul className="space-y-3">
              {navigationLinks.map((link) =>
                link.dropdown ? (
                  link.dropdown.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className="text-gray-400 hover:text-white"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ),
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-5">Contact</h3>

            <div className="space-y-4 text-sm text-gray-400">
              <a href={`tel:${companyInfo.phone1}`} className="flex gap-3">
                <Phone className="w-4 h-4 mt-1" />
                {companyInfo.phone1}
              </a>
              <a href={`tel:${companyInfo.phone2}`} className="flex gap-3">
                <Phone className="w-4 h-4 mt-1" />
                {companyInfo.phone2}
              </a>

              <a href={`mailto:${companyInfo.email}`} className="flex gap-3">
                <Mail className="w-4 h-4 mt-1" />
                {companyInfo.email}
              </a>

              <a
                href="https://g.co/kgs/JBGXRww"
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3"
              >
                <MapPin className="w-4 h-4 mt-1 shrink-0" />
                {companyInfo.address}
              </a>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h3 className="text-lg font-bold mb-5">Let’s Connect</h3>

            <p className="text-gray-400 text-sm leading-7 mb-5">
              Looking for reliable dye manufacturing solutions? Contact our team
              today.
            </p>

            <Link
              to="/contact"
              className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium"
            >
              Contact Us
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-center text-sm text-gray-500">
          © {year} {companyInfo.name}. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
